// Réglages modifiables du site public (chiffres, mentions, offres, suivi publicitaire)
export const STAT_PRISE_EN_CHARGE = "9 projets sur 10";
export const MENTION_CONDITIONS = "Selon la configuration du bâtiment et l'éligibilité au dispositif CEE. Le reste à charge éventuel est annoncé dans l'étude gratuite, avant tout engagement.";

// Date de fin du Coup de pouce Chauffage, ex. "31 décembre 2026". Vide = aucune date affichée.
export const COUP_DE_POUCE_DATE_FIN = "";

// Identifiants de suivi, chargés uniquement après consentement (bannière cookies). Vide = non chargé.
export const GA_ID = ""; // Google Analytics, ex. "G-XXXXXXX"
export const GOOGLE_ADS_ID = ""; // Google Ads, ex. "AW-XXXXXXX"
export const LINKEDIN_PARTNER_ID = ""; // LinkedIn Insight Tag, ex. "1234567"

export const SITE_URL = "https://airthermo.fr";
